import { ProjectLastUsedDto, UserFullDto } from '../../api/api-types';
import { GET_EMPLOYEE_DATA, GET_REGISTERED_EMPLOYEE } from '../actions';

export const getEmployeeDataAction = (data: ProjectLastUsedDto) =>
  GET_EMPLOYEE_DATA({ payload: data });

export const getRegisteredEmployeeAction = (data: UserFullDto) =>
  GET_REGISTERED_EMPLOYEE({ payload: data });
